module.exports = __webpack_public_path__ + "img/GAL.660aa877.svg";